<template>
  <Tour :newWork="newWork" :offLine="true" v-if="newWork.base.id"></Tour>
</template>

<script>

import Tour from "../../../public/ssr/components/tour/Tour";

import "../../../public/ssr/static/css/redefine.css";
import { getWorkDetail } from "@/api/work";
import { workJson } from "@/offline/work";

export default {
  components: {
    Tour
  },
  data() {
    return {
      newWork: {
        base: {},
        ads: {},
        sets: {},
        menus: [],
        guide: [],
        sandtable: []
      },
    }
  },
  computed: {
  },
  methods: {
    workJson() {
      workJson().then((res) => {
        this.workInit(res);
      });
    },
    workDetail() {
      let uuid = this.$route.params.id;
      getWorkDetail({ uuid })
        .then((res) => {
          this.workInit(res);
        })
        .catch(() => {});
    },
    workInit(res) {
      if (res.code === 1) {
        document.title = res.data.base.name;
        this.newWork = res.data;
      }
    },
  },
  created() {
    if (process.env.VUE_APP_ENV == "offline") {
      this.workJson();
    } else {
      this.workDetail();
    }
  },
  mounted() {
  },
};
</script>